import { toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { LinkedList } from 'vscode/vscode/vs/base/common/linkedList';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { Emitter } from 'vscode/vscode/vs/base/common/event';

class OutlineService {
    constructor() {
        this._factories = ( new LinkedList());
        this._onDidChange = ( new Emitter());
        this.onDidChange = this._onDidChange.event;
    }
    canCreateOutline(pane) {
        for (const factory of this._factories) {
            if (factory.matches(pane)) {
                return true;
            }
        }
        return false;
    }
    async createOutline(pane, target, token) {
        for (const factory of this._factories) {
            if (factory.matches(pane)) {
                return await factory.createOutline(pane, target, token);
            }
        }
        return undefined;
    }
    registerOutlineCreator(creator) {
        const rm = this._factories.push(creator);
        this._onDidChange.fire();
        return toDisposable(() => {
            rm();
            this._onDidChange.fire();
        });
    }
}

export { OutlineService };
